import Angle from "../entities/Angle/Angle";
import { AnglePoints, AngleProps } from "../types/Interface";
import calcAngles from "../utils/math/calcAngles"
import getDistanceBtwPoints from "../utils/getDistanceBtwPoints";
import { rootEventBus, EnumRootEventBus } from "./RootEventBus";


export default class BaseAngleManager {
  rootEventBus = rootEventBus;
  EnumRootEventBus = EnumRootEventBus;

  Angles: Angle[] = [];
  constructor(anglePropsArr: AngleProps[], followCircleAnim: boolean = true) {
    this.Angles = anglePropsArr
      .map((angleProps, aI) => new Angle(`a${aI + 1}`, angleProps.angleColors, angleProps.smallDistanceOffset, angleProps.addCon, angleProps.addSmallDis));
    if(followCircleAnim){
      this.rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false));
      this.rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true));
    }
  }

  setAllVisible = (v: boolean) => this.Angles.forEach(angle => angle.setVisible(v));
  getAngles = () => this.Angles;

  drawAngle(angle: Angle, p: AnglePoints, degree: number, clockwise: boolean) {
    const { startRadian, endRadian } = calcAngles(p.curr, p.prev, p.next);
    const smllDistance = Math.floor(Math.min(getDistanceBtwPoints(p.curr, p.prev), getDistanceBtwPoints(p.curr, p.next)));

    angle.smallDistance = smllDistance;
    angle.draw(p.curr, startRadian, endRadian, degree, !clockwise);
    angle.x = p.curr.x;
    angle.y = p.curr.y;
    angle.rotation = 0;
  }
}